import { HttpClient } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AuthService } from './auth.service';
import {GlobalVariable} from '../global';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {
  private baseUrl: string = GlobalVariable.BASE_URL;
  private lang: string = localStorage.getItem('site_lang') ?? 'en';
  returnToMonth: string | null = null;
  private monthListV2Cache$: Observable<any> | null = null;
  private monthListV2CacheToken: string | null = null;
  private monthListV2CacheDate: string | null = null;
  private monthWithTimesheetIdCache$: Observable<any> | null = null;
  private monthWithTimesheetIdCacheToken: string | null = null;
  private monthWithTimesheetIdCacheDate: string | null = null;
  private monthListForRepCache$: Observable<any> | null = null;
  private monthListForRepCacheToken: string | null = null;
  private monthListForRepCacheDate: string | null = null;
  private associatesCache = new Map<string, Observable<any>>();
  private tsInfoSummaryCache = new Map<string, Observable<any>>();
  private timesheetDataCache = new Map<string, Observable<any>>();
  constructor(private http: HttpClient, private auth: AuthService) {
    // ログアウト時にタイムシート関連キャッシュを全破棄
    this.auth.loggedOut$.subscribe(() => {
      this.timesheetDataCache.clear();
      this.tsInfoSummaryCache.clear();
      this.associatesCache.clear();
      this.monthListV2Cache$ = null;
      this.monthListV2CacheToken = null;
      this.monthListV2CacheDate = null;
      this.monthWithTimesheetIdCache$ = null;
      this.monthWithTimesheetIdCacheToken = null;
      this.monthWithTimesheetIdCacheDate = null;
      this.monthListForRepCache$ = null;
      this.monthListForRepCacheToken = null;
      this.monthListForRepCacheDate = null;
    });
  }
  
  getTimeSheetById(id: any) {

    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheetlineitem/'+id;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getTimeSheetLogById(id: any) {

    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheetlineitem/'+id+'?isLogs=true';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  getTimeSheetByIdCached(id: any): Observable<any> {
    const key = String(id);
    if (!this.timesheetDataCache.has(key)) {
      const apiKey = this.auth.getToken();
      const apiUrl = this.baseUrl + '/timesheetlineitem/' + id;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`
      };
      const obs = this.http.get<any>(apiUrl, { headers }).pipe(shareReplay(1));
      this.timesheetDataCache.set(key, obs);
    }
    return this.timesheetDataCache.get(key)!;
  }

  invalidateTimesheetDataCache(id?: any): void {
    if (id !== undefined) {
      this.timesheetDataCache.delete(String(id));
    } else {
      this.timesheetDataCache.clear();
    }
  }

  getTsInfoSummary(timesheetId: any) {
    const apiKey = this.auth.getToken();
    const cacheKey = `${apiKey}_${timesheetId}`;
    if (this.tsInfoSummaryCache.has(cacheKey)) return this.tsInfoSummaryCache.get(cacheKey)!;

    const base = environment.useApiGateway ? environment.apiGatewayUrl : this.baseUrl;
    const endpoint = environment.useApiGateway ? '/tsinfo/summary/' : '/TsInfo/summary/';
    let apiUrl = base + endpoint + timesheetId;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };
    const obs = this.http.get<any>(apiUrl, { headers }).pipe(shareReplay(1));
    this.tsInfoSummaryCache.set(cacheKey, obs);
    return obs;
  }

  clearTsInfoSummaryCache(timesheetId?: any): void {
    if (timesheetId !== undefined) {
      const token = this.auth.getToken();
      this.tsInfoSummaryCache.delete(`${token}_${timesheetId}`);
    } else {
      this.tsInfoSummaryCache.clear();
    }
  }
  
  getNoteTypes() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/dropdown/getnotetypes';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getExpensesTypes() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/dropdown/getexpensestypes';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  saveTimeSheet(Obj:any){
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/timesheetlineitem";
    const headers = {
      // lang: this.lang,
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.post<any>(targetUrl, Obj,{ headers });
  }

  getAssociates(endDate: any) {
    const apiKey = this.auth.getToken();
    const cacheKey = `${apiKey}_${endDate ?? ''}`;
    if (this.associatesCache.has(cacheKey)) return this.associatesCache.get(cacheKey)!;

    let apiUrl = '';
    if (endDate) {
      apiUrl = this.baseUrl+'/timesheetsummary/summary?weekEndingDate='+endDate;
    } else {      
      apiUrl = this.baseUrl+'/timesheetsummary/summary';
    }
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };
    const obs = this.http.get<any>(apiUrl, { headers }).pipe(shareReplay(1));
    this.associatesCache.set(cacheKey, obs);
    return obs;
  }

  clearAssociatesCache(): void {
    this.associatesCache.clear();
  }
  
  getAssociatesNew(endDate: any, sectionId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = '';
    if (endDate) {
      apiUrl = this.baseUrl+'/timesheetsummary/summarynew?weekEndingDate='+endDate+'&sectionId='+sectionId;
    } else {      
      apiUrl = this.baseUrl+'/timesheetsummary/summary';
    }
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getAssociatesBatchList(endDate: any, customeID: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = '';    
    apiUrl = this.baseUrl+'/timesheetlineitem/getbydaydate?isLogs=false&dayDate='+endDate+'&companyId='+customeID;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getMonthList() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/joborder/weekend-series';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getMonthListV2(): Observable<any> {
    const currentToken = this.auth.getToken();
    const today = new Date().toDateString(); // 例: "Thu Mar 20 2026"
    const isCacheValid = this.monthListV2Cache$ !== null
      && this.monthListV2CacheToken === currentToken
      && this.monthListV2CacheDate === today;

    if (!isCacheValid) {
      this.monthListV2CacheToken = currentToken;
      this.monthListV2CacheDate = today;
      const apiUrl = this.baseUrl + '/joborder/weekend-series-v2';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${currentToken}`
      };
      this.monthListV2Cache$ = this.http.get<any>(apiUrl, { headers }).pipe(
        shareReplay(1)
      );
    }
    return this.monthListV2Cache$!;
  }

  clearMonthListCache(): void {
    this.monthListV2Cache$ = null;
    this.monthListV2CacheToken = null;
    this.monthListV2CacheDate = null;
  }
  
  getMonthListForRep(): Observable<any> {
    const currentToken = this.auth.getToken();
    const today = new Date().toDateString();
    const isCacheValid = this.monthListForRepCache$ !== null
      && this.monthListForRepCacheToken === currentToken
      && this.monthListForRepCacheDate === today;
    if (!isCacheValid) {
      this.monthListForRepCacheToken = currentToken;
      this.monthListForRepCacheDate = today;
      const apiUrl = this.baseUrl + '/joborder/weekend-series-rep';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${currentToken}`
      };
      this.monthListForRepCache$ = this.http.get<any>(apiUrl, { headers }).pipe(shareReplay(1));
    }
    return this.monthListForRepCache$!;
  }

  clearMonthListForRepCache(): void {
    this.monthListForRepCache$ = null;
    this.monthListForRepCacheToken = null;
    this.monthListForRepCacheDate = null;
  }
  
  getDateList() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/joborder/day-series';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  getAproveAllDateList() {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/joborder/day-series-approve-all';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  getMonthWithTimesheetId(): Observable<any> {
    const currentToken = this.auth.getToken();
    const today = new Date().toDateString();
    const isCacheValid = this.monthWithTimesheetIdCache$ !== null
      && this.monthWithTimesheetIdCacheToken === currentToken
      && this.monthWithTimesheetIdCacheDate === today;

    if (!isCacheValid) {
      this.monthWithTimesheetIdCacheToken = currentToken;
      this.monthWithTimesheetIdCacheDate = today;
      const apiUrl = this.baseUrl + '/joborder/contractseriesbyloginid';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${currentToken}`
      };
      this.monthWithTimesheetIdCache$ = this.http.get<any>(apiUrl, { headers }).pipe(
        shareReplay(1)
      );
    }
    return this.monthWithTimesheetIdCache$!;
  }

  clearMonthWithTimesheetIdCache(): void {
    this.monthWithTimesheetIdCache$ = null;
    this.monthWithTimesheetIdCacheToken = null;
    this.monthWithTimesheetIdCacheDate = null;
  }
  getMonthWithTimesheetIdNew(userId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/joborder/contractseriesbyloginid?AscId='+userId;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  approveRejectTimeSheet(Obj:any){
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/timesheetlineitem/approve-reject-batch";
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.post<any>(targetUrl, Obj,{ headers });
  }

  getEtcThread(lineItemId: any, language: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheetlinemodify/'+lineItemId+'?lang='+language;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getPdf(timeSheetId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheet/download/'+timeSheetId;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    // return this.http.get<any>(apiUrl, { headers });
    return this.http.get(apiUrl, {
      responseType: 'blob',     
        observe: 'response',
      headers
    });
  }

  getMprepPdf(timesheetId: number) {
    const apiKey = this.auth.getToken();
    let apiUrl = `${this.baseUrl}/Timesheet/mprep/Download/${timesheetId}`;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get(apiUrl, {
      responseType: 'blob',
      observe: 'response',
      headers
    });
  }
  
  getBulkPdf(yearMonth: string, customerCode: string) {
    const apiKey = this.auth.getToken();
    const params = `yearMonth=${encodeURIComponent(yearMonth)}&customerCode=${encodeURIComponent(customerCode)}`;
    const apiUrl = `${this.baseUrl}/timesheet/bulk-download?${params}`;
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.get(apiUrl, {
      responseType: 'blob',
      observe: 'response',
      headers
    });
  }
  
  getMPrepBulkPdf(yearMonth: string, customerCode: string): Observable<HttpResponse<Blob>> {
    const apiKey = this.auth.getToken();
    const params = `yearMonth=${encodeURIComponent(yearMonth)}&customerCode=${encodeURIComponent(customerCode)}`;
    const apiUrl = `${this.baseUrl}/timesheet/mprep/bulk-download?${params}`;
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.get(apiUrl, {
      responseType: 'blob',
      observe: 'response',
      headers
    });
  }

  updateClaimHistory(Obj: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/timesheet/updatecomplaintcomments";
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(targetUrl, Obj,{ headers });  
  }
  
  updateTrainingHistory(Obj: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/timesheet/updatetrainingcomments";
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(targetUrl, Obj,{ headers });  
  }

  updateOrderCOmment(Obj: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/joborder/update-comments";
    const headers = {
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(targetUrl, Obj,{ headers });  
  }
  
  getCmpList(endDate: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheetsummary/summary-grouped-by-company?weekEndingDate='+endDate;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getContractSummary(endDate: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/clientjoborder/contractsummarybyclientid?date='+endDate;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }
  
  getlogUserAction(procId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/loguseraction/byuser?procId='+procId;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get<any>(apiUrl, { headers });
  }

  downloadTimesheetingleAll(comId: any, date: any, sectionId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/timesheetsummary/downloadtimesheetsummary?weekEndingDate=' + date + '&companyId=' + comId+'&sectionId='+sectionId;
    
    // TimesheetSummary/DownloadTimeSheetSummary
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    // return this.http.get<any>(apiUrl, { headers });
    return this.http.get(apiUrl, {
      responseType: 'blob',     
        observe: 'response',
      headers
    });    
  }
  
  downloadContractListSingleAll(comId: any, date: any, sectionId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/clientjoborder/downloadcontractlist?weekendDate=' + date + '&companyId=' + comId+'&sectionId='+sectionId;
    
    // TimesheetSummary/DownloadTimeSheetSummary
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    // return this.http.get<any>(apiUrl, { headers });
    return this.http.get(apiUrl, {
      responseType: 'blob',     
        observe: 'response',
      headers
    });    
  }
  
  downloadTimesheet(date: any, staffId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/timesheetsummary/downloadtimesheetsummary?weekEndingDate=' + date + '&companyId=-1&sectionId=-1&ascId='+staffId;
    
    // TimesheetSummary/DownloadTimeSheetSummary
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    // return this.http.get<any>(apiUrl, { headers });
    return this.http.get(apiUrl, {
      responseType: 'blob',     
        observe: 'response',
      headers
    });    
  }

  downloadContractListSingle(comId: any, date: any, staffId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/clientjoborder/downloadcontractlist?weekendDate=' + date + '&companyId=' + comId+'&sectionId=-1&ascId='+staffId;
    
    // TimesheetSummary/DownloadTimeSheetSummary
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    // return this.http.get<any>(apiUrl, { headers });
    return this.http.get(apiUrl, {
      responseType: 'blob',     
      observe: 'response',
      headers
    });    
  }

  downloadContract(date: any, staffId: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl + '/clientjoborder/downloadcontractlist?weekendDate=' + date + '&companyId=-1&sectionId=-1&ascId='+staffId;
    
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.get(apiUrl, {
      responseType: 'blob',     
      observe: 'response',
      headers
    });    
  }

  getSectionByCompanyId(companyId: any, endDate: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/timesheetsummary/summary-grouped-by-section?weekEndingDate='+endDate;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.get<any>(apiUrl, { headers });    
  }
  
  getContractSummarySection(companyId: any, endDate: any) {
    const apiKey = this.auth.getToken();
    let apiUrl = this.baseUrl+'/clientjoborder/contractsummarybyclientidgroupedbysections?date='+endDate;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`
    };
    return this.http.get<any>(apiUrl, { headers });    
  }

}
